import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsPermissionsNextGenRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels-permissions-next-gen',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
	exact: true,
};
